import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, RequestOptions, URLSearchParams } from '@angular/http';
import { GlobalInfo, FPMessage, Severities, RoleGroups } from '.././shared/shared.model';
import { SharedService, Status } from '.././shared/shared.service';
import { MenuItem, SubMenuItem } from './menu.model';
// import { SETTINGS } from '.././core/app-config';

@Component({
    // moduleId: module.id,
    selector: 'detailed-menu',
    templateUrl: 'detailed-menu.component.html'
})
export class DetailedMenuComponent implements OnInit {
    globalInfo: GlobalInfo;
    SiteaAdmin: boolean = false;
    adminMenuCount: number = 0;
    reportMenuCount: number = 0;
    constructor(private router: Router, private sharedService: SharedService) {
        //super();       
        this.globalInfo = this.sharedService.globalInfo();

    }
    @Input() menus: MenuItem[];
    @Output() dismiss = new EventEmitter();
    megamenus: MenuItem[] = [];
    reportmenus: MenuItem[] = [];
    adminmenus: MenuItem[] = [];
    ngOnInit() {
        // body.classList.add("no-scroll ovrdesk-hide");   //add the class
        this.megamenus = this.menus.filter(c => c.ParentMenuId != 1 && c.ParentMenuId != 73 && c.ParentMenuId != 82);
        this.reportmenus = this.menus.filter(c => c.ParentMenuId == 73);
        this.adminmenus = this.menus.filter(c => c.ParentMenuId == 82);//
        this.adminMenuCount = this.adminmenus.filter(f => f.Childrens.length).length;
        this.reportMenuCount = this.reportmenus.filter(f => f.Childrens.length).length;
    }

    ValidURL(str) {
        var re = new RegExp("^(http|https)://");
        if (!re.test(str))
            return false;
        else
            return true;
    }
    menuClick(url: string, isExternal: boolean) {

        if (this.dismiss)
            this.dismiss.emit();

        if (url == null || url == "") { return; }

        if (this.ValidURL(url)) {
            // For External Tab
            if (isExternal) {
                window.open(url, "_blank");
                return;
            } else {
                var urls = url.split(':');
                var parsedurl = parseInt(urls[2]);
                let redir = '';
                if (parsedurl)
                    redir = urls[0] + ":" + urls[1] + ":" + parsedurl;
                else
                    redir = urls[0] + ":" + urls[1];
                url = url.split('//')[1];
                url = url.replace(url.split('/')[0], "");
                window.open(redir + '/' + url + "?uri=" + url, "_self")
                return;
            }
        }

        switch (url) {
            case 'managecustomers':
                this.router.navigate(['/customview/customer']);
                break;
            case '/customview/customer?create=true':
                this.router.navigate(['/customview/customer'], { queryParams: { create: true, random: Math.random() } });
                break;
            case '/customview/ManageProjects?create=true':
                    this.router.navigate(['/customview/ManageProjects'], { queryParams: { create: true, random: Math.random() } });
                    break;
            case 'createpm':
                this.router.navigate(['/pm/pm'], { queryParams: { create: true, random: Math.random() } });
                break;
            case '/pm/pmequipmentcreate':
                this.router.navigate(['/pm/pmequipment'], { queryParams: { create: true, random: Math.random() } });
                break;
            case '/project/createproject':
                this.router.navigate(['/project'], { queryParams: { create: true, random: Math.random() } });
                break;
            case '/admin/company':
                this.router.navigate(['/company/company']);
                break;
            case '/workorder/createworkorder':
                this.router.navigate(['/' + url + "/" + 0]);
                break;
            default:
                if (url.substring(0, 19).trim().toLowerCase() == "/reports/dashboards") {
                    var a = url.split('id=')[1];
                    var b = new URLSearchParams('id=' + a);
                    var id = b.get('id');
                    var pageUrl = url.split('?id=')[0];
                    this.router.navigate([pageUrl + "/" + id]);
                }
                else
                    this.router.navigate([url]);
                break;
        }
    }
    
    reportmenuclick(url: string) {
        if (url === 'adhocrunreports')
            this.router.navigate(['/admin/reports/type=run']);
    }

}